import { chapeterSelectors } from './articleListedElements';
import { articleListedState as state } from './articleListedState';
import * as Sentry from '@sentry/browser';

// nastaví hodnotu option na aktuální kapitolu všem <select> s kapitolama na webu (Auto.cz)
export const articleListedSelectSetOption = async (): Promise<void> => {
  const chapter = await new Promise<string | null>((resolve) => {
    resolve(state.getActiveChapter() as unknown as string | null);
  });

  if (chapter !== null) {
    chapeterSelectors.forEach((chapterSelectElement) => {
      const selectElement = chapterSelectElement as HTMLSelectElement;

      if (selectElement) {
        selectElement.value = chapter;
        const optionExists = Array.from(selectElement.options).some(
          (option) => option.value == chapter
        );
        if (!optionExists) {
          Sentry.captureException('TopicBanner: chybí obsah šablony');
        }
      }
    });
  }
};
